import { render, staticRenderFns } from "./AccountPayables.vue?vue&type=template&id=4cb96e39&"
import script from "./AccountPayables.vue?vue&type=script&lang=js&"
export * from "./AccountPayables.vue?vue&type=script&lang=js&"
import style0 from "./AccountPayables.vue?vue&type=style&index=0&id=4cb96e39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports